// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__mD8SR","checkbox":"SuperCheckbox_checkbox__rEGcr","spanClassName":"SuperCheckbox_spanClassName__8TSHL"};